/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

class UserImageDownloadService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "userImageDownload");
    }

    public async userImageDownload(resolved: (base64Text: string) => void, rejected: (error: any) => void) {
        await super.getDownloadFile(resolved, rejected);
    }
}

export default UserImageDownloadService;
